import {Stack} from "@src/CommonComponents/Stack/Stack.tsx";
import styles from "../Pages/Views/Employee/CheckInOut/checkInPage.module.less";
import {ClockOutCheck} from "@UI/illustrationsSvg/ClockOutCheck.tsx";
import {
    Body_14_Coral_Primary_Regular_14,
    Title_20_Coral_Strong_emphasis_20
} from "@UI/typography/generated/typography.tsx";
import {Gt} from "@src/i18n/Gt.tsx";
import {Button, ButtonType} from "@UI/components/controls/Button/Button.tsx";
import {Checked} from "@UI/components/icons/Checked.tsx";
import {Xcross} from "@UI/components/icons/Xcross.tsx";
import {CheckBox} from "@src/CommonComponents/CheckBox/CheckBox.tsx";
import {useModalState} from "@src/Store/modalStore.ts";
import {ColorNames} from "@UI/theme/generated/ColorNames.ts";


export const AskFinishWork = ({cancelHandler, executeAction}: { cancelHandler?: () => void, executeAction?: () => void }) => {
    const checked = useModalState((s) => s.checked);
    const setChecked = useModalState((s) => s.setChecked);

    return (
        <Stack grow alignItems={"center"} justifyContent={"center"} direction={"column"} gap={16}
               className={styles.checkPopup}>
            <ClockOutCheck/>
            <Stack direction={"column"} alignItems={"center"} justifyContent={"center"} className={styles.text}>
                <Stack className={styles.title} justifyContent={"center"}>
                    <Title_20_Coral_Strong_emphasis_20>
                        <Gt>Is it okay if I leave work like this?</Gt>
                    </Title_20_Coral_Strong_emphasis_20>
                </Stack>
            </Stack>
            <Stack className={styles.buttons} justifyContent={"center"} alignItems={"center"}>
                <Button type={ButtonType.third}
                        icon={<Checked/>}
                        onClick={executeAction}
                        className={styles.popupButton}>
                    <Gt>Clock out</Gt>
                </Button>
                <Button type={ButtonType.primary} icon={<Xcross/>}
                        color={ColorNames.CORAL_MOSS}
                        onClick={cancelHandler}
                        className={styles.popupButton}><Gt>Cancel</Gt></Button>
            </Stack>
            <Stack alignItems={"center"} justifyContent={"center"} gap={8}>
                <CheckBox onValueChange={setChecked} checked={checked}/>
                <Body_14_Coral_Primary_Regular_14>
                    <Gt>Don't show this again</Gt>
                </Body_14_Coral_Primary_Regular_14>
            </Stack>
        </Stack>
    )
}